import { createFileRoute } from "@tanstack/react-router";
import { FAQs } from "@/components/FAQs";

function RouteComponent() {
  return <FAQs />;
}

export const Route = createFileRoute("/_authenticated/faqs/")({
  component: RouteComponent,
  staticData: { page: "admin" },
});
